import { useCallback, useState } from 'react'

import { isBrokerCarrier, type Shipment } from '../../domain/Shipment'
import { AssetCarrierCardContent } from './AssetCarrierCardContent'
import { AssetCarrierDialog } from './AssetCarrierDialog'
import { EffectiveCarrierCard } from './EffectiveCarrierCard'

type AssetCarrierCardProps = {
  readonly shipment: Shipment
  readonly onAssetCarrierAssigned: (uuid: string) => void
}

export function AssetCarrierCard({ shipment, onAssetCarrierAssigned }: AssetCarrierCardProps) {
  const [dialogOpen, setDialogOpen] = useState(false)

  const handleAssignAssetCarrier = useCallback(() => {
    onAssetCarrierAssigned(shipment.uuid)
  }, [onAssetCarrierAssigned, shipment.uuid])

  if (!isBrokerCarrier(shipment)) {
    return null
  }

  return (
    <>
      {shipment.effectiveCarrier ? (
        <EffectiveCarrierCard
          effectiveCarrier={shipment.effectiveCarrier}
          onClick={() => setDialogOpen(true)}
        />
      ) : (
        <AssetCarrierCardContent onClick={() => setDialogOpen(true)} />
      )}

      {dialogOpen && (
        <AssetCarrierDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          effectiveCarrier={shipment.effectiveCarrier}
          shipmentUUID={shipment.uuid}
          onAssetCarrierAssigned={handleAssignAssetCarrier}
        />
      )}
    </>
  )
}
